import React from 'react'
import './BodyHeader.css';
import { Link } from 'react-router-dom';

export default function BodyHeader({title, text}) {
  return (
    <div className='BodyHeader-Body'>
        <p className='BodyHeader-Text1'>{title}</p>
        <div className='BodyHeader-Box'>
            <Link className='BodyHeader-Link'>Home</Link>
            <p className='BodyHeader-Text2'>||</p>
            <p  className='BodyHeader-Text3'>{text}</p>
        </div>
    </div>
  )
}
